import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

const WebPromoCarousel = (props) => {
    const divRef = useRef({});
    const { renderCarousel: Carousel, navigation } = props;

    const testIDSlug =
        navigation?.state?.params?.pageOptions?.parentSlug ||
        navigation?.state?.params?.pageOptions?.slug;

    useEffect(() => {
        const handleScroll = (event) => {
            if (event.deltaX !== 0) {
                event.preventDefault();
                event.stopPropagation();
            }
        };

        divRef.current?.addEventListener('mousewheel', handleScroll, { passive: false });

        return () => {
            divRef.current?.removeEventListener('mousewheel', handleScroll, { passive: false });
        };
    });

    return (
        <div data-testid={`${testIDSlug ? `${testIDSlug}_` : ''}top_promo`} ref={divRef}>
            <Carousel {...props} />
        </div>
    );
};

WebPromoCarousel.propTypes = {
    renderCarousel: PropTypes.func.isRequired,
    navigation: PropTypes.shape({}).isRequired
};

export default WebPromoCarousel;
